// ---------------------------------------------------------------------------
// V34 — THE OFFLINE QUEUE AND THE IMPORT, over HTTP.
//
// Request specs only. Nothing here decides anything: which capture wins is
// `app.sync_offline_batch`'s, and which columns a file may carry is
// `app.import_format`'s.
// ---------------------------------------------------------------------------

import { mutate, read } from "./console";

/** One row of `app.sync_outcome`, with this organisation's count. */
export type QueueOutcome = {
  outcome: string;
  label: string;
  /** The catalogue's own sentence. Rendered as it comes; nothing paraphrases it. */
  description: string;
  needs_attention: boolean;
  rank: number;
  captures: string;
  last_received_at: string | null;
};

/** A capture somebody has to decide about. */
export type OfflineConflict = {
  capture_id: string;
  assignment_id: string;
  worker_id: string;
  given_name: string;
  family_name: string;
  kind: string;
  kind_label: string;
  outcome: string;
  outcome_label: string;
  clock_ruling: string | null;
  ruling_label: string | null;
  /** ★ The rule about which clock decided, from `app.clock_ruling.description`. */
  ruling_description: string | null;
  recorded_effective_at: string | null;
  capture_admitted_at: string | null;
  device_reported_at: string;
  received_at: string;
  device_skew_seconds: number | null;
  disagreement_seconds: number | null;
  refusal_reason: string | null;
};

export type ImportFormat = {
  id: string;
  label: string;
  description: string;
  source_product: string;
  delimiter: string;
  column_map: Record<string, string>;
  /** The columns this format treats as taxonomy: counted, never stored. */
  category_columns: string[];
  rank: number;
};

export type ImportBatch = {
  batch_id: string;
  format: string;
  format_label: string;
  filename: string;
  row_count: number;
  created_at: string;
  created: string;
  matched: string;
  incomplete: string;
  refused: string;
};

export type ImportOutcome = {
  line_no: number;
  outcome: string;
  outcome_label: string;
  worker_id: string | null;
  refusal_reason: string | null;
};

export const offline = {
  queue: (base: string) => read(base, "/v1/offline/queue"),
  conflicts: (base: string) => read(base, "/v1/offline/conflicts"),
  sync: (base: string, captures: unknown[]) => mutate("POST", base, "/v1/offline/sync", { captures }),
};

export const imports = {
  formats: (base: string) => read(base, "/v1/imports/formats"),
  history: (base: string) => read(base, "/v1/imports/history"),
  upload: (base: string, format: string, filename: string, text: string) =>
    mutate("POST", base, "/v1/imports/workers", { format, filename, text }),
};
